<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import LoadingContentView from "../../../../../component/common/Loading/LoadingContentView.svelte";
    import ArraySlotView from "../../../../../component/common/Value/ArraySlotView.svelte";
    import FontAwesomeView from "../../../../../component/common/Image/FontAwesomeView.svelte";
    import BinaryTagView from "./BinaryTagView.svelte";

    const dispatcher = createEventDispatcher();

    export let spaceUniqueId;
    export let appUniqueId;
    export let binary;
    export let canEdit = false;
    export let canJumpUrl = false;

    let isLoading = false;
    let binaryTags = null;

    onMount(() => {
    });


    function onClickAddTag() {
        dispatcher('openAddBinaryTag', {binary: binary});
    }


</script>

<div class="binary-tag-area-view">
    <LoadingContentView isLoading={isLoading}>
        <div class="binary-tag-area">
            <div class="binary-tags">
                <ArraySlotView array={binary.binary_tags} dataName="タグ">


                    <div class="binary-tag-content">
                        {#each binary.binary_tags as binaryTag}
                            <BinaryTagView spaceUniqueId={spaceUniqueId} appUniqueId={appUniqueId} binaryTag={binaryTag}
                                           canJumpUrl={canJumpUrl}
                                           on:update
                                           isShowDelete={canEdit}/>
                        {/each}
                    </div>


                </ArraySlotView>

            </div>
            {#if canEdit}
                <div class="button-area">
                    <button class="add-button" on:click={onClickAddTag}>
                        <FontAwesomeView icon="plus"/>
                        追加
                    </button>
                </div>
            {/if}

        </div>

    </LoadingContentView>


</div>
<style lang="scss">
    .binary-tag-area-view {
        display: inline-block;

        .binary-tag-area {
            display: flex;
            gap: 16px;

            .binary-tags {
                flex-grow: 1;

                .binary-tag-content {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 4px;
                }
            }

            .button-area {
                display: inline-flex;
                align-items: flex-end;


                .add-button {
                    padding-left: 0.5em;
                    padding-right: 0.5em;
                    font-size: 0.75em;

                }
            }

        }

    }
</style>